module.exports = __webpack_public_path__ + "static/Assets-Panel-f5676dd16749805f9127b1e4ce64d204.png";